export default {
  operateSettlement: {
    reportTitle: '经营报表',
    reportDescription: '按时间范围和统计维度查看经营收入与预存金数据。',
    summaryTitle: '经营数据汇总',
    metric: { share: '占比' },
    prepaidSummary: '预存金汇总',
    prepaidPrincipalReceived: '实收本金',
    prepaidPrincipalRefund: '本金退款',
    prepaidGiftReceived: '实收赠金',
    prepaidGiftRefund: '赠金退款',
    dimensionSummary: '分维度统计',
    filterDateRange: '统计日期',
    filterStoreGroup: '门店区域',
    filterProductKeyword: '商品名称',
    groupAll: '全部区域',
    groupEast: '华东区域',
    groupSouth: '华南区域',
    groupNorth: '华北区域',
    dimensionStore: '按门店',
    dimensionProduct: '按商品',
    dimensionProductType: '按商品类型',
    dimensionBackendCategory: '按后台分类',
    dimensionFrontCategory: '按前台分类',
    dimensionSalesChannel: '按售卖渠道',
    dimensionPayChannel: '按支付渠道',
    metricActualNet: '实际净收',
    metricReceived: '实收金额',
    metricRefund: '退款金额',
    metricPrepaidSpent: '预存金消费',
    metricPrepaidRefund: '预存金退款',
    metricPrepaidNet: '预存金净消费',
    metricNetSales: '净销售额',
    metricShare: '净销售额占比',
    metricPrepaidShare: '预存金净消费占比',
    help: {
      summaryActualNet: '实际资金净收 = 实际资金收款 - 实际资金退款，允许为负数。预存金消费及预存金余额退款不计入实际资金收付；已确认冲正计入冲正发生日，不回写历史。',
      summaryReceived: '业务系统确认整笔支付成功后，将订单实际资金收款计入营业日；预存金消费及未成功订单不计入。跨日分笔支付按支付成功日统计。',
      summaryRefund: '按退款成功营业日统计退回的实际资金，不含预存金余额退款；尚未成功的退款不计入，不回写历史结果。',
      summaryPrepaidSpent: '整单成功营业日使用的预存金本金与赠金，不是充值收款。',
      summaryPrepaidRefund: '退款成功营业日退回的预存金本金与赠金，不是实际资金流出。',
      summaryPrepaidNet: '预存金净消费 = 预存金消费金额 - 预存金退款金额，可为负数。',
      dimension: {
        store: '按销售归属门店汇总，展示门店名称。',
        product: '按销售商品汇总。',
        productType: '按商品类型汇总。',
        backendCategory: '按商品所属后台分类汇总。',
        frontCategory: '按商品所属前台分类汇总。',
        salesChannel: '按订单销售渠道汇总。',
        payChannel: '按订单支付渠道汇总。',
      },
      tableStoreGroup: '按门店统计时展示门店所属的门店组；其他统计维度不按门店组拆分，此列显示“-”。',
      tableOrderCount: '所选营业日范围内，完成收款的销售订单按订单主键计数。同一订单多笔支付只计一单，后续退款不冲减订单数。',
      tableSalesQuantity: '所选筛选范围内按当前统计维度汇总的商品销售数量。',
      tableReceived: '所选营业日范围内，整单成功订单的实际资金收款，不含预存金消费；按当前维度汇总，退款单独列示。组合支付按支付明细归集，不重复计入整单金额。',
      tableRefund: '按退款成功营业日统计退回的实际资金，不含预存金余额退款；尚未成功的退款不计入，不回写历史结果。',
      tableActualNet: '实际资金净收 = 实际资金收款 - 实际资金退款，与顶部卡片同口径；不含预存金消费及余额退款，允许为负数。',
      tableNetSales: '净销售额 = 实际资金收款 + 预存金消费 - 实际资金退款 - 预存金退款。',
      tablePrepaidSpent: '整单成功营业日使用的预存金本金与赠金，不是充值收款。',
      tablePrepaidRefund: '退款成功营业日退回的预存金本金与赠金，不是实际资金流出。',
      tablePrepaidNet: '预存金净消费 = 预存金消费金额 - 预存金退款金额，可为负数。',
      tableRefundOrderCount: '所选期间发生成功退款的原订单主键数，同一订单跨多日退款也仅计一次。',
      tableShare: '本行净销售额 ÷ 当前筛选结果的净销售额合计 × 100%。分母包含全部筛选结果，不仅是当前页；分母为 0 时显示 0%。',
      tablePrepaidShare: '本行预存金净消费 ÷ 当前筛选结果的净销售额合计 × 100%。分母为 0 时显示 0%。',
    },
    columnStore: '门店名称',
    columnProduct: '商品名称',
    columnProductType: '商品类型',
    columnBackendCategory: '后台分类',
    columnFrontCategory: '前台分类',
    columnSalesChannel: '售卖渠道',
    columnPayChannel: '支付渠道',
    columnStoreGroup: '门店区域',
    columnOrderCount: '订单数',
    columnSalesQuantity: '销售数量',
    columnRefundOrderCount: '退款订单数',
    mockStoreA: '华东一店',
    mockStoreB: '华东二店',
    mockStoreC: '华东三店',
    mockStoreD: '华南一店',
    mockStoreE: '华南二店',
    mockStoreF: '华南三店',
    mockStoreG: '华北一店',
    mockStoreH: '华北二店',
    mockProductTicket: '单次游玩票',
    mockProductPackage: '亲子畅玩套票',
    mockProductGame: '互动游戏体验',
    mockProductGift: '主题纪念礼品',
    mockTypeTicket: '门票',
    mockTypePackage: '套票',
    mockTypeGame: '互动体验',
    mockTypeGoods: '零售商品',
    mockBackendTicket: '门票类',
    mockBackendGame: '游乐项目',
    mockBackendGoods: '商品零售',
    mockFrontPopular: '热门推荐',
    mockFrontFamily: '亲子游玩',
    mockFrontGift: '礼品周边',
    mockChannelCounter: '门店收银',
    mockChannelMiniProgram: '微信小程序',
    mockChannelSelfService: '自助设备',
    mockPayCash: '现金',
    mockPayWechat: '微信支付',
    mockPayAlipay: '支付宝',
    businessDate: '营业日期',
    conclusionTitle: '门店日结概况',
    conclusionSummary: '共 {total} 家门店，已完成日结 {settled} 家，待日结 {pending} 家。',
    previousDay: '前一天',
    nextDay: '后一天',
    metrics: '日结指标',
    settlementProgress: '日结进度',
    settlementProgressHint: '完成率 {percentage}%，还有 {pending} 家待处理',
    snapshotNetIncome: '日结净收入',
    snapshotNetIncomeHint: '已完成 {count} 家门店的日结快照',
    pendingEstimatedIncome: '待日结预估收入',
    pendingEstimatedIncomeHint: '来自 {count} 家待日结门店',
    attentionStores: '需关注门店',
    storesUnit: '家',
    attentionStoresHint: '存在退款、现金差异或日结延迟',
    pendingRefundAmount: '待处理退款金额',
    pendingRefundAmountHint: '共 {count} 笔退款待处理',
    attentionTitle: '需关注门店',
    attentionSubtitle: '以下门店存在日结或资金核对事项',
    noAttentionStores: '暂无需关注门店',
    storeOverview: '门店日结列表',
    storeOverviewSubtitle: '当前筛选到 {total} 家门店',
    statusFilter: '日结状态筛选',
    notSettled: '未日结',
    noAttention: '无异常',
    viewDetails: '查看详情',
    storeSettlementDetails: '门店日结详情',
    readOnlySnapshot: '只读快照',
    snapshotAndEstimate: '日结快照与实时预估',
    snapshotAt: '快照时间：{time}',
    notAvailable: '暂无数据',
    realtimeEstimate: '实时预估收入',
    snapshotEstimateNote: '日结快照为完成日结时保存的数据；实时预估会随订单变化。',
    amountSummary: '金额汇总',
    grossIncome: '营业总额',
    discountAmount: '优惠金额',
    refundAmount: '退款金额',
    netIncome: '净收入',
    orderOverview: '订单概览',
    totalOrders: '订单总数',
    completedOrders: '完成订单',
    refundedOrders: '退款订单',
    cancelledOrders: '取消订单',
    channelSummary: '渠道汇总',
    channelDineIn: '堂食',
    channelTakeaway: '自提',
    channelDelivery: '外送',
    paymentWechat: '微信支付',
    paymentAlipay: '支付宝',
    paymentCash: '现金',
    paymentOther: '其他支付',
    refundAndCashCheck: '退款与现金核对',
    refundOverview: '退款概况',
    pendingRefunds: '待处理退款金额',
    refundCount: '退款笔数',
    refundStatus: '退款状态',
    refundStatusValue: { pending: '待处理', none: '无待处理退款' },
    cashReconciliation: '现金核对',
    expectedCash: '应收现金',
    actualCash: '实收现金',
    cashDifference: '现金差异',
    reconciliationResult: '核对结果',
    reconciliation: { matched: '一致', difference: '存在差异' },
    shiftInformation: '班次信息',
    shiftCount: '{count} 个班次',
    shiftMorning: '早班',
    shiftEvening: '晚班',
    mockCashierA: '张敏',
    mockCashierB: '李伟',
    shiftCashier: '收银员：{name}',
    shiftNetIncome: '班次净收入',
    searchKeyword: '门店名称',
    storeScope: '门店区域',
    scopeAll: '全部区域',
    scopeNorth: '华北区域',
    scopeEast: '华东区域',
    scopeSouth: '华南区域',
    scopeWest: '华西区域',
    settlementStatus: '日结状态',
    status: { all: '全部', settled: '已日结', pending: '待日结' },
    table: {
      storeName: '门店名称',
      scope: '所属区域',
      status: '日结状态',
      netAmount: '净收入',
      refundAmount: '退款金额',
      settlementTime: '日结时间',
      attention: '关注事项',
      action: '操作',
    },
    currencySymbol: '¥',
    attentionCashDifference: '现金核对存在差异',
    attentionRefundPending: '存在待处理退款',
    attentionNotSettled: '尚未完成日结',
    attentionLateSettlement: '日结时间较晚',
    mockStore01: '上海旗舰店',
    mockStore02: '上海浦东店',
    mockStore03: '上海徐汇店',
    mockStore04: '广州天河店',
    mockStore05: '广州番禺店',
    mockStore06: '深圳南山店',
    mockStore07: '北京朝阳店',
    mockStore08: '北京海淀店',
    mockStore09: '杭州西湖店',
    mockStore10: '杭州滨江店',
    mockStore11: '南京新街口店',
    mockStore12: '苏州中心店',
    mockStore13: '成都春熙路店',
    mockStore14: '重庆解放碑店',
    mockStore15: '武汉光谷店',
    mockStore16: '西安钟楼店',
    mockStore17: '天津和平店',
    mockStore18: '青岛市南店',
    mockStore19: '厦门思明店',
    mockStore20: '长沙五一广场店',
  },
};
